import { type UseQueryResult, useQuery } from 'react-query';
import { NoticeService } from '../../services/wealthlane-award-services';

const useGetGrantAcceptanceTemplateVariables = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<string> | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const grantAcceptanceTemplateVariables = useQuery(
    ['getGrantAcceptanceTemplateVariables'],
    async () => {
      return await handleRequest(NoticeService.getApiAwardApiNoticesGrantAcceptanceVariables());
    }
  );

  return grantAcceptanceTemplateVariables;
};

export default useGetGrantAcceptanceTemplateVariables;
